/**
 * @fileoverview Error thrown by useExportLineage when the backend answers the export POST with a refusal.
 */

/**
 * The POST was answered and refused. `message` is operator copy (it may carry the HTTP status) and
 * is never shown to users (see isPlumbingError); `refusal` is the backend's reason when it wrote one
 * for the person, and the dialog reads that field explicitly. `status` is the HTTP status, kept on
 * the instance for Sentry and never interpolated into the message.
 */
export class ExportRefusedError extends Error {
  readonly refusal: string | null
  readonly status: number | undefined
  constructor(message: string, refusal: string | null, status?: number) {
    super(message)
    this.name = 'ExportRefusedError'
    this.refusal = refusal
    this.status = status
  }
}

export function isExportRefusedError(err: unknown): err is ExportRefusedError {
  return err instanceof ExportRefusedError
}
